<template>
    <header class="tw-relative tw-z-10">
        <nav class="tw-w-2/3 tw-mx-auto tw-flex tw-items-center tw-h-[54px]">
            <a href="/#/signup">
                <img :src="require('@/modules/Signup/__clients/ezi/logo.svg')" alt="logo" />
            </a>
            <menu class="tw-flex">
                <li><a href="#">nbn&reg; Plans</a></li>
                <li><a href="#">About</a></li>
                <li><a href="#">nbn&reg; Fibre Upgrade</a></li>
            </menu>
        </nav>
    </header>
</template>

<style scoped>
header {
    background: linear-gradient(90deg, #FF0090 0%, #FF5064 100%);
}
</style>